import * as React from 'react';
import { ProductCatalogList } from '../components/Menu';

export const menuConfigItems = {
  profile: {
    root: true,
    title: 'SUBMENU.PROFILE',
    translate: 'SUBMENU.PROFILE',
    page: 'settings/profile',
    activePages: ['settings/profile'],
  },

  logout: {
    root: true,
    title: 'MENU.LOGOUT',
    translate: 'MENU.LOGOUT',
    page: 'logout',
    // icon: 'flaticon-logout',
  },

  products: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['products', 'categories', 'viewproduct'],
    inActivePages: ['products/types'],
    page: 'products/catalog',
    submenu: [
      {
        title: 'PRODUCT.ALL.PRODUCTS',
        translate: 'PRODUCT.ALL.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      // {
      //   title: 'PRODUCT.ALL.NEW_PRODUCTS',
      //   page: 'products/new',
      //   translate: 'PRODUCT.ALL.NEW_PRODUCTS',
      // },
      {
        title: 'MENU.COMPANY.PRODUCTS',
        page: 'products/list',
        translate: 'MENU.COMPANY.PRODUCTS',
      },
      // {
      //   title: 'PRODUCT.ADD.MULTIPLY.PRODUCTS',
      //   translate: 'PRODUCT.ADD.MULTIPLY.PRODUCTS',
      //   page: 'products/add_multiply',
      // },
      // {
      //   title: 'PRODUCT.ADD.PRICE.EDITING.PRODUCTS',
      //   translate: 'PRODUCT.ADD.PRICE.EDITING.PRODUCTS',
      //   page: 'products/edit_pricing',
      // },
      // {
      //   title: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      //   page: 'products/favorites',
      //   translate: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      // },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorProducts: {
    title: 'MENU.PRODUCTS',
    translate: 'MENU.PRODUCTS',
    bullet: 'dot',
    root: true,
    activePages: ['products', 'categories', 'viewproduct'],
    page: 'products/catalog',
    submenu: [
      {
        title: 'MENU.CATALOG.PRODUCTS',
        translate: 'MENU.CATALOG.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'MENU.COMPANY.PRODUCTS',
        page: 'products/list',
        translate: 'MENU.COMPANY.PRODUCTS',
        activePages: ['products/edit', 'products/create'],
      },
      // {
      //   title: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      //   page: 'products/favorites',
      //   translate: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      // },
      {
        title: 'MENU.CATALOG.CATEGORIES.LIST',
        page: 'categories/list',
        translate: 'MENU.CATALOG.CATEGORIES.LIST',
        activePages: ['categories/edit', 'categories/new'],
      },
      {
        title: 'MENU.CATALOG.CATEGORIES.TREE',
        page: 'categories/tree',
        translate: 'MENU.CATALOG.CATEGORIES.TREE',
      },
    ],
  },

  vendorCompany: {
    root: true,
    title: 'MENU.VENDOR.COMPANY',
    translate: 'MENU.VENDOR.COMPANY',
    bullet: 'dot',
    activePages: ['companies', 'stores'],
    submenu: [
      {
        translate: 'SUBMENU.COMPANY_SETTINGS',
        title: 'SUBMENU.COMPANY_SETTINGS',
        page: 'companies/list',
        activePages: ['companies/edit', 'companies/new'],
      },
      {
        translate: 'MENU.CATALOG.STORES',
        title: 'MENU.CATALOG.STORES',
        page: 'stores/list',
        activePages: ['stores/edit', 'stores/create'],
      },
    ],
  },

  tenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    activePages: ['tenders/'],
    submenu: [
      {
        translate: 'SUBMENU.ALLTENDERS',
        title: 'SUBMENU.ALLTENDERS',
        page: 'tenders/list/full',
      },
    ],
  },

  allTenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'tenders/list/full',
    activePages: ['tenders', 'tenders/list/full'],
    submenu: [
      {
        translate: 'SUBMENU.ALLTENDERS',
        title: 'SUBMENU.ALLTENDERS',
        page: 'tenders/list/full',
      },
    ],
  },

  buyersTenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'tenders/list/full',
    activePages: ['tenders'],
    submenu: [
      {
        translate: 'SUBMENU.ALLTENDERS',
        title: 'SUBMENU.ALLTENDERS',
        page: 'tenders/list/full',
      },
      {
        translate: 'SUBMENU.MYTENDERS',
        title: 'SUBMENU.MYTENDERS',
        page: 'tenders/list/my',
      },
    ],
  },

  vendorsTenders: {
    root: true,
    title: 'MENU.TENDERS',
    translate: 'MENU.TENDERS',
    bullet: 'dot',
    page: 'tenders/list/full',
    activePages: ['tenders'],
    submenu: [
      {
        translate: 'SUBMENU.TENDER.VENDOR',
        title: 'SUBMENU.TENDER.VENDOR',
        page: 'tenders/list/full',
      },
    ],
  },

  shifts: {
    root: true,
    title: 'MENU.SHIFTS',
    translate: 'MENU.SHIFTS',
    bullet: 'dot',
    page: 'shifts/calendar',
    activePages: ['shifts'],
    submenu: [
      {
        translate: 'SUBMENU.SHIFTS.CALENDAR',
        title: 'SUBMENU.SHIFTS.CALENDAR',
        page: 'shifts/calendar',
      },
      {
        translate: 'LIST',
        title: 'LIST',
        page: 'shifts/list',
      },
    ],
  },

  addTender: {
    root: true,
    title: 'TENDER.BUTTON.ADD',
    translate: 'TENDER.BUTTON.ADD',
    bullet: 'dot',
    page: 'tenders/create',
    submenu: [
      {
        translate: 'MENU.MY_COMPANY',
        title: 'MENU.MY_COMPANY',
        page: 'companies/list',
      },
    ],
  },

  orders: {
    root: true,
    title: 'MENU.ORDERS',
    translate: 'MENU.ORDERS',
    bullet: 'dot',
    activePages: ['orders/'],
    page: 'orders/list/full',
    submenu: [
      {
        translate: 'SUBMENU.ALLORDERS',
        title: 'SUBMENU.ALLORDERS',
        page: 'orders/list/full',
      },
      // {
      //   translate: 'SUBMENU.ALLTENDERS',
      //   title: 'SUBMENU.ALLTENDERS',
      //   page: 'tenders/list/full',
      // },
      // {
      //   title: 'MENU.SEARCH',
      //   translate: 'MENU.SEARCH',
      //   page: 'product_search/list',
      // },
      // {
      //   title: 'MENU.DELIVERY.DOCUMENTS',
      //   translate: 'MENU.DELIVERY.DOCUMENTS',
      //   page: 'delivery/list/full',
      // },
      {
        translate: 'SUBMENU.ABANDONEDCHECKOUTS',
        title: 'SUBMENU.ABANDONEDCHECKOUTS',
        page: 'orders/list/abandoned',
      },
      // {
      //   translate: 'SUBMENU.REQUESTS',
      //   title: 'SUBMENU.REQUESTS',
      //   page: 'requests/list/',
      // },
    ],
  },

  buyersDocuments: {
    root: true,
    title: 'MENU.DELIVERY.DOCUMENTS',
    translate: 'MENU.DELIVERY.DOCUMENTS',
    bullet: 'dot',
    page: 'delivery/list/full',
  },

  buyersDocumentsHistory: {
    root: true,
    title: 'MENU.DELIVERY.DOCUMENTS.HISTORY',
    translate: 'MENU.DELIVERY.DOCUMENTS.HISTORY',
    bullet: 'dot',
    page: 'delivery/list/history',
  },

  buyersOrders: {
    root: true,
    title: 'MENU.MY_ORDERS',
    translate: 'MENU.MY_ORDERS',
    bullet: 'dot',
    page: 'orders/list/full',
    activePages: ['orders'],
  },

  companies: {
    root: true,
    title: 'MENU.COMPANIES',
    translate: 'MENU.COMPANIES',
    bullet: 'dot',
    activePages: ['companies', 'stores', 'viewcompany'],
    page: 'companies/list',
    submenu: [
      {
        translate: 'MENU.CATALOG.STORES',
        title: 'MENU.CATALOG.STORES',
        page: 'stores/list',
      },
    ],
  },

  users: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/buyers',
    // submenu: [
    //   {
    //     translate: 'SUBMENU.CUSTOMERS',
    //     title: 'SUBMENU.CUSTOMERS',
    //     page: 'users/buyers',
    //   },
    //   {
    //     translate: 'SUBMENU.VENDORS',
    //     title: 'SUBMENU.VENDORS',
    //     page: 'users/vendors',
    //   },
    //   {
    //     translate: 'SUBMENU.VENDORS.STAFF',
    //     title: 'SUBMENU.VENDORS.STAFF',
    //     page: 'users/staff',
    //   },
    //   {
    //     translate: 'SUBMENU.TEAM',
    //     title: 'SUBMENU.TEAM',
    //     page: 'users/managers',
    //   },
    //   {
    //     translate: 'SUBMENU.COMPANIES',
    //     title: 'SUBMENU.COMPANIES',
    //     page: 'companies/list',
    //   },
    //   {
    //     translate: 'SUBMENU.CONTENT_MANAGER',
    //     title: 'SUBMENU.CONTENT_MANAGER',
    //     page: 'users/content-managers',
    //   },
    // ],
  },
  balanceRequests: {
    root: true,
    title: 'Balance Requests',
    translate: 'Balance Requests',
    bullet: 'dot',
    activePages: ['balancerequests'],
    page: 'balancerequests',
  },
  sendReceiveRequest: {
    root: true,
    title: 'Send/Receive Request',
    translate: 'Send/Receive Request',
    bullet: 'dot',
    activePages: ['sendReceiveRequest'],
    page: 'sendReceiveRequest',
  },

  transactions: {
    root: true,
    title: 'Transactions',
    translate: 'Transactions',
    bullet: 'dot',
    activePages: ['transactions'],
    page: 'transactions',
  },

  usersManager: {
    root: true,
    title: 'MENU.USERS',
    translate: 'MENU.USERS',
    bullet: 'dot',
    activePages: ['users'],
    page: 'users/vendors',
    submenu: [
      {
        translate: 'SUBMENU.VENDORS',
        title: 'SUBMENU.VENDORS',
        page: 'users/vendors',
      },
      {
        translate: 'SUBMENU.VENDORS.STAFF',
        title: 'SUBMENU.VENDORS.STAFF',
        page: 'users/staff',
      },
      {
        translate: 'SUBMENU.COMPANIES',
        title: 'SUBMENU.COMPANIES',
        page: 'companies/list',
      },
    ],
  },

  vendorUsers: {
    root: true,
    title: 'MENU.TEAM',
    translate: 'MENU.TEAM',
    bullet: 'dot',
    page: 'users/managers',
    activePages: ['users'],
  },

  settings: {
    root: true,
    title: 'MENU.SETTINGS',
    bullet: 'dot',
    translate: 'MENU.SETTINGS',
    activePages: ['products/types'],
    page: 'products/types/list',
    submenu: [
      {
        title: 'MENU.PRODUCTS.TYPES',
        translate: 'MENU.PRODUCTS.TYPES',
        page: 'products/types/list',
        activePages: ['products/types/create'],
      },
      // {
      //   title: 'MENU.PRODUCTS.BANNERS',
      //   translate: 'MENU.PRODUCTS.BANNERS',
      //   page: 'banners/list',
      //   activePages: ['banners', 'banners/create', 'banners/edit'],
      // },
      // {
      //   title: 'GROUPS',
      //   translate: 'GROUPS',
      //   page: 'groups/list',
      //   activePages: ['groups/list'],
      // },
      // {
      //   title: 'COLLECTIONS',
      //   translate: 'COLLECTIONS',
      //   page: 'collections/list',
      //   activePages: ['collections/list'],
      // },
      // {
      //   title: 'MENU.PRODUCTS.PROMOCODES',
      //   translate: 'MENU.PRODUCTS.PROMOCODES',
      //   page: 'promocodes/list',
      //   activePages: ['promocodes', 'promocodes/edit', 'promocodes/new'],
      // },
      // {
      //   title: 'MENU.PRODUCTS.REFFERALS',
      //   translate: 'MENU.PRODUCTS.REFFERALS',
      //   page: 'refferals/list',
      //   activePages: ['refferals', 'refferals/edit', 'refferals/new'],
      // },
      // {
      //   title: 'MENU.PRODUCTS.TRANSACTIONS',
      //   translate: 'MENU.PRODUCTS.TRANSACTIONS',
      //   page: 'transactions/list',
      //   activePages: ['transactions'],
      // },
      // {
      //   title: 'MENU.LOYALTY',
      //   translate: 'MENU.LOYALTY',
      //   page: 'loyalties/list',
      //   activePages: ['loyalties'],
      // },
    ],
  },

  legal: {
    root: true,
    title: 'SUBMENU.LEGAL',
    translate: 'SUBMENU.LEGAL',
    bullet: 'dot',
    activePages: ['documents'],
    page: 'documents/legacy',
    submenu: [
      {
        title: 'SUBMENU.LEGAL_TERMS',
        translate: 'SUBMENU.LEGAL_TERMS',
        page: 'documents/legacy',
      },
      {
        title: 'SUBMENU.LEGAL_PRIVACY',
        translate: 'SUBMENU.LEGAL_PRIVACY',
        page: 'documents/privacy',
      },
      // {
      //   title: 'SUBMENU.LEGAL_SHIPPING',
      //   translate: 'SUBMENU.LEGAL_SHIPPING',
      //   page: 'documents/shipping',
      // },
      // {
      //   title: 'SUBMENU.LEGAL_REFUND',
      //   translate: 'SUBMENU.LEGAL_REFUND',
      //   page: 'documents/refund',
      // },
    ],
  },

  catalog: {
    root: true,
    title: 'MENU.CATALOG.PRODUCTS',
    translate: 'MENU.CATALOG.PRODUCTS',
    bullet: 'dot',
    // icon: 'flaticon-book',
    page: 'products/catalog',
    dynamic: () => <ProductCatalogList />,
    activePages: ['products', 'viewproduct'],
    submenu: [
      {
        title: 'MENU.CATALOG.PRODUCTS',
        translate: 'MENU.CATALOG.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      // {
      //   title: 'COLLECTIONS',
      //   translate: 'COLLECTIONS',
      //   page: 'collections/list',
      //   activePages: ['collections/list'],
      // },
    ],
  },

  catalogForUser: {
    root: true,
    title: 'MENU.CATALOG.PRODUCTS',
    translate: 'MENU.CATALOG.PRODUCTS',
    bullet: 'dot',
    // icon: 'flaticon-book',
    page: 'products/catalog',
    dynamic: () => <ProductCatalogList />,
    activePages: ['products', 'viewproduct'],
    submenu: [
      {
        title: 'MENU.CATALOG.PRODUCTS',
        translate: 'MENU.CATALOG.PRODUCTS',
        page: 'products/catalog',
        activePages: ['products/catalog'],
        dynamic: () => <ProductCatalogList />,
      },
      {
        title: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
        page: 'products/favorites',
        translate: 'CATEGORIES.TABLE.TOOLTIP.FAVORITES_PRODUCTS',
      },
      // {
      //   title: 'COLLECTIONS',
      //   translate: 'COLLECTIONS',
      //   page: 'collections/list',
      //   activePages: ['collections/list'],
      // },
    ],
  },

  login: {
    root: true,
    title: 'MENU.LOGIN',
    translate: 'MENU.LOGIN',
    bullet: 'dot',
    // icon: 'flaticon-login',
    page: 'auth',
  },

  blog: {
    root: true,
    title: 'SUBMENU.BLOG',
    translate: 'SUBMENU.BLOG',
    bullet: 'dot',
    activePages: ['blog'],
    page: 'blog/my',
    submenu: [
      {
        title: 'SUBMENU.BLOG.ALL',
        page: 'blog/all',
        translate: 'SUBMENU.BLOG.ALL',
        activePages: ['blog/edit', 'blog/create', 'blog/view'],
      },
      {
        title: 'SUBMENU.BLOG.MY',
        page: 'blog/my',
        translate: 'SUBMENU.BLOG.MY',
      },
    ],
  },

  search: {
    root: true,
    title: 'MENU.SEARCH',
    translate: 'MENU.SEARCH',
    bullet: 'dot',
    page: 'product_search/list',
    activePages: ['product_search'],
  },

  guestBlog: {
    root: true,
    title: 'SUBMENU.BLOG.ALL',
    translate: 'SUBMENU.BLOG.ALL',
    bullet: 'dot',
    page: 'blog/all',
    activePages: ['blog'],
  },

  tariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    activePages: ['tariffs'],
    page: 'tariffs/list/vendors',
    submenu: [
      {
        title: 'SUBMENU.TARIFFS.BUYERS',
        page: 'tariffs/list/buyers',
        translate: 'SUBMENU.TARIFFS.BUYERS',
      },
      {
        title: 'SUBMENU.TARIFFS.VENDORS',
        page: 'tariffs/list/vendors',
        translate: 'SUBMENU.TARIFFS.VENDORS',
      },
    ],
  },

  buyersTariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    page: 'tariffs/list/buyers',
    activePages: ['tariffs'],
  },

  vendorsTariffs: {
    root: true,
    title: 'SUBMENU.TARIFFS',
    translate: 'SUBMENU.TARIFFS',
    bullet: 'dot',
    page: 'tariffs/list/vendors',
    activePages: ['tariffs'],
  },

  chats: {
    root: true,
    title: 'SUBMENU.CHATS',
    translate: 'SUBMENU.CHATS',
    bullet: 'dot',
    page: 'chats',
    activePages: ['chats'],
  },
  productDashboard: {
    title: 'MENU.DASHBOARD',
    translate: 'MENU.DASHBOARD',
    bullet: 'dot',
    root: true,
    page: 'dashboard/list',
    // inActivePages: ['dashboard'],
  },

  statistic: {
    root: true,
    title: 'SUBMENU.STATISTIC',
    translate: 'SUBMENU.STATISTIC',
    bullet: 'dot',
    activePages: ['statistics'],
    submenu: [
      {
        title: 'SUBMENU.STATISTIC.ORDERS',
        page: 'statistics/list/orders',
        translate: 'SUBMENU.STATISTIC.ORDERS',
      },
      {
        title: 'SUBMENU.STATISTIC.PRODUCTS',
        page: 'statistics/list/products',
        translate: 'SUBMENU.STATISTIC.PRODUCTS',
      },
      {
        title: 'SUBMENU.DETAIL.STATISTIC.ORDERS',
        page: 'statistics/list/detailed/orders',
        translate: 'SUBMENU.DETAIL.STATISTIC.ORDERS',
      },
    ],
  },

  vendorRequests: {
    root: true,
    title: 'REQUEST.TITLE',
    translate: 'REQUEST.TITLE',
    bullet: 'dot',
    page: 'requests/create',
    activePages: ['requests'],
  },

  buyerRequests: {
    root: true,
    title: 'REQUEST.TITLE',
    translate: 'REQUEST.TITLE',
    bullet: 'dot',
    page: 'requests/create',
    activePages: ['requests'],
  },
};
